import React from "react";
import classNames from "classnames";
import { TrashIcon } from "@/shared/icons";
import type { ButtonProps } from "antd/lib";
import { AppButton } from "../../AppButton";
import baseBtn from "../styles.module.scss";
import styles from "./styles.module.scss";

interface Props extends ButtonProps {
  buttonText: string;
  onClick?: () => void;
  className?: string;
}

export const DeletedButton: React.FC<Props> = ({ buttonText, className, onClick, ...props }) => {
  return (
    <AppButton
      icon={<TrashIcon className={classNames(styles["delete-icon"])} />}
      onClick={onClick}
      className={classNames(baseBtn["contacts-btn"], styles["delete-btn"], className)}
      {...props}
    >
      {buttonText}
    </AppButton>
  );
};
